module.exports = __webpack_public_path__ + "static/img/2.ff46683.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/zh/2.png
// module id = /X6S
// module chunks = 0